<ion-content>
  <main>
    <user-section-title [sectionTitle]="'recoverpassword' | translate"></user-section-title>
    <section *ngIf="!invalidUserToken()">
      <form [formGroup]="userForm" (submit)="resetPassword()" (keydown.enter)="resetPassword()">
        <div
          class="myWrapInput"
          [class.has-error]="!userForm.get('password').valid 
            && userForm.get('password').enabled && userForm.get('password').touched && userForm.get('password').dirty"
        >
          <ion-item
            lines="none"
            class="cdr-item-input"
            [class.error]="!userForm.get('password').valid 
          && userForm.get('password').enabled && userForm.get('password').touched && userForm.get('password').dirty"
          >
            <ion-input
              label="Contraseña"
              labelPlacement="floating"
              formControlName="password"
              [type]="showPassword.password ? 'text' : 'password'"
              autocomplete="off"
              autoCorrect="off"
              spellcheck="off"
              [clearOnEdit]="false"
              [class.ion-input-error]="!userForm.get('password').valid 
            && userForm.get('password').enabled && userForm.get('password').touched && userForm.get('password').dirty"
            ></ion-input>
            <ion-icon
              [name]="showPassword.password ? 'eye-off' : 'eye'"
              (click)="toggleTypeInput('password')"
            ></ion-icon>
          </ion-item>
          <div
            [hidden]="userForm.get('password').disabled || userForm.get('password').valid 
                || userForm.get('password').untouched || !userForm.get('password').dirty"
            class="labelError"
          >
            <span>{{getErrors(userForm.get('password')) | translate}}</span>
          </div>
        </div>
        <div
          class="myWrapInput"
          [class.has-error]="!userForm.get('passwordConfirm').valid 
                && userForm.get('passwordConfirm').enabled && userForm.get('passwordConfirm').touched && userForm.get('passwordConfirm').dirty"
        >
          <ion-item
            lines="none"
            class="cdr-item-input"
            [class.error]="!userForm.get('passwordConfirm').valid 
                    && userForm.get('passwordConfirm').enabled && userForm.get('passwordConfirm').touched && userForm.get('passwordConfirm').dirty"
          >
            <ion-input
              label="Repetir contraseña"
              labelPlacement="floating"
              [type]="showPassword.confirmPassword ? 'text' : 'password'"
              formControlName="passwordConfirm"
              autocomplete="off"
              autoCorrect="off"
              spellcheck="off"
              [clearOnEdit]="false"
              [class.ion-input-error]="!userForm.get('passwordConfirm').valid 
              && userForm.get('passwordConfirm').enabled && userForm.get('passwordConfirm').touched && userForm.get('passwordConfirm').dirty"
            ></ion-input>
            <ion-icon
              [name]="showPassword.confirmPassword ? 'eye-off' : 'eye'"
              (click)="toggleTypeInput('confirmPassword')"
            ></ion-icon>
          </ion-item>
          <div
            [hidden]="userForm.get('passwordConfirm').disabled || userForm.get('passwordConfirm').valid 
                    || userForm.get('passwordConfirm').untouched || !userForm.get('passwordConfirm').dirty"
            class="labelError"
          >
            <span>{{getErrors(userForm.get('passwordConfirm')) | translate}}</span>
          </div>
        </div>

        <ion-button type="submit" class="validatetbn" expand="full">{{'validate' | translate}}</ion-button>
      </form>
    </section>
    <section *ngIf="invalidUserToken()">
      <div class="invalidusertoken">
        <div class="borderred">
          <div>
            <ion-icon name="close-circle"></ion-icon>
          </div>
          <div class="txtlink">{{'linkreset' | translate}}</div>
        </div>
        <ion-row>
          <ion-col size="6">
            <ion-button expand="full" (click)="openLogin()">{{'acces' | translate}}</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button expand="full" (click)="openLogin(true)">{{'recoverpassword' | translate}}</ion-button>
          </ion-col>
        </ion-row>
      </div>
    </section>
  </main>
  <codere-footer></codere-footer>
</ion-content>
